import { Alert } from 'antd';
import React from 'react';
import './style.scss';

const ErrorHandle = ({ message, docLevelErrors, lineLevelErrors }) => {
  const renderErrors = (errors, type) => {
    if (!errors?.length) return null;

    const visibleErrors = errors?.slice(0, 5); // Show the first 5 errors
    const remainingCount = errors?.length - 5;

    return (
      <li>
        {type}
        {' '}
        errors:
        <ol className="error-list">
          {visibleErrors?.map((error, index) => (
            <li key={`${type}-error-${index}`}>{error?.message}</li>
          ))}
          {remainingCount > 0 && (
            <li className="error-more">{`...${remainingCount} more error${remainingCount > 1 ? 's' : ''}`}</li>
          )}
        </ol>
      </li>
    );
  };

  return (
    <div className="error-handle__wrapper">
      <Alert
        showIcon
        type="error"
        message={message}
        description={(
          <ul>
            {renderErrors(docLevelErrors, 'Document')}
            {renderErrors(lineLevelErrors, 'Line')}
          </ul>
        )}
      />
    </div>
  );
};

export default ErrorHandle;
